export const Colors = {
    NAV_COL: "#252829",
    NAV_ERROR_COL: "#CC0C39",
    NAV_WARN_COL: "#DCB700",
    WHITE_COL: "#FFFFFF",
    GREY_COL_100: "#F0F1F2",
    GREY_COL_200: "#E7E9E9",
    GREY_COL_50: "#F9FAFA",
    GREY_COL_300: "#BBC0C1"
};